//#region Modules
import {
  IUserSubscriptionStatusRecord,
  PremiumSubscriptionPaymentProvider,
  PremiumSubscriptionPlanPeriod,
  SubscriptionDataT,
} from "@anydo/interfaces";
import { immerable } from "@anydo/vendor/immer";
import { RecordUtils } from "./-private/RecordUtils";
//#endregion

//#region Default properties
const getDefaultProperty = RecordUtils.createGetDefaultProperty<IUserSubscriptionStatusRecord>({
  activePlan: "",
  cardExpirationMonth: null,
  cardExpirationYear: null,
  cardLast4: "",
  isCanceled: false,
  paymentProvider: PremiumSubscriptionPaymentProvider.WHITELIST,
  planPeriod: null,
  serverExpirationDate: 0,
  subscriptionData: null,
  subscriptionDate: 0,
  isReverseTrial: false,
});
//#endregion

export class UserSubscriptionStatusRecord implements IUserSubscriptionStatusRecord {
  //#region Static
  static [immerable] = true;

  static create(props?: Partial<IUserSubscriptionStatusRecord>) {
    return new UserSubscriptionStatusRecord(props);
  }
  //#endregion

  activePlan: string | null;
  cardExpirationMonth: number | null;
  cardExpirationYear: number | null;
  cardLast4: string | null;
  isCanceled: boolean;
  paymentProvider: PremiumSubscriptionPaymentProvider;
  planPeriod: PremiumSubscriptionPlanPeriod | null;
  serverExpirationDate: number;
  subscriptionData: SubscriptionDataT | null;
  subscriptionDate: number;
  isReverseTrial: boolean | undefined;

  constructor(props?: Partial<IUserSubscriptionStatusRecord>) {
    this.activePlan = getDefaultProperty("activePlan", props);
    this.cardExpirationMonth = getDefaultProperty("cardExpirationMonth", props);
    this.cardExpirationYear = getDefaultProperty("cardExpirationYear", props);
    this.cardLast4 = getDefaultProperty("cardLast4", props);
    this.isCanceled = getDefaultProperty("isCanceled", props);
    this.paymentProvider = getDefaultProperty("paymentProvider", props);
    this.planPeriod = getDefaultProperty("planPeriod", props);
    this.serverExpirationDate = getDefaultProperty("serverExpirationDate", props);
    this.subscriptionData = getDefaultProperty("subscriptionData", props);
    this.subscriptionDate = getDefaultProperty("subscriptionDate", props);
    this.isReverseTrial = getDefaultProperty("isReverseTrial", props);
  }
  //#region Methods
  get<K extends keyof IUserSubscriptionStatusRecord>(key: K): UserSubscriptionStatusRecord[K] {
    return this[key];
  }

  set<K extends keyof IUserSubscriptionStatusRecord>(
    key: K,
    value: IUserSubscriptionStatusRecord[K],
  ): UserSubscriptionStatusRecord {
    return RecordUtils.updateImmutableInstace<IUserSubscriptionStatusRecord, UserSubscriptionStatusRecord, K>(
      UserSubscriptionStatusRecord,
      this,
      key,
      value,
    );
  }
  //#endregion
}

export function isUserSubscriptionStatusRecord(obj: any): obj is UserSubscriptionStatusRecord {
  return obj != null && obj instanceof UserSubscriptionStatusRecord;
}
